<template>
  <NuxtLayout name="app">
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup>
</script>
